// Queries and mutations unique to the Dashboard module
import { gql } from 'apollo-boost';

// Dashboard data
export const MAIN_DASHBOARD_QUERY = gql`
query currentStudent($date: String) {
    currentStudent {
        id
        name
        avatarJson
        active
        firstName
        loginCode
        expiredToken
        boomerAvatarUrl
        backgroundImageUrl
        updatedAt
        boombassadorCounter
        isBoombassador
        boombassadorAccepted
        dailyBoombassadorStats {
          dailyStats
          weeklyStats
          yearlyStats
        }
        availableGems
        academicYearTotalBooksCompleted
        academicYearTotalGemsEarned
        dailyStreak
        dailyTotalGemsEarned(date: $date)
        currentReadingRank {
            id
            readingBandRank {
                id
                name
                colourCode
            }
        }
        school {
            id
            name
            allowSeens
            allowLikes
            schoolCode
            weekStart
            canAccessBoomWriteApp
        }
        classes {
            id
            name
            teachers {
                id
                displayName
            }
        }
        readingBooks {
            addedBy {
                id
                displayName
            }
            id
            status
            bookType
            logs {
                id
                date
            }
            book {
                id
                author
                description
                title
                coverUrl
                isbn
                isbn13
            }
        }
        groupReadingBooks {
            id
            status
            addedBy {
                id
                displayName
            }
            book {
                id
                author
                description
                title
                coverUrl
                isbn
                isbn13
            }
            logs {
                id
                date
            }
            students {
                id
            }
        }
    
    }
}
`;


export const GET_SCHOOL_REVIEWS = gql`
query schoolByCode($schoolCode: ID!, $limit: Int, $offset: Int) {
    schoolByCode(schoolCode: $schoolCode)  {
        id
        bookReviews(limit: $limit, offset: $offset) {
            id
            reviewRate
            reviewText
            date
            status
            book {
                id
                title
                author 
            }
            author {
                id
                name
                boomerAvatarUrl
                updatedAt
            }
        }
      
    }
}
`;

export const GET_STUDENT_READING_LOGS_TARGET = gql`
query currentStudent($weekStart: String!) {
    currentStudent {
        id
        studentWeeklyTarget {
            id
            parentLogsTarget
            studentId
            studentLogsTarget
            teacherLogsTarget
        }
        weeklyStudentReportData(weekStart: $weekStart) {
            id
            parentLogsCount
            parentLogsTarget
            studentLogsCount
            studentLogsTarget
            teacherLogsCount
            teacherLogsTarget
            weekStart
        }
    }
}
`;
